import { EngageMessagesState, createEngageMessagesSlice } from './engage/createEngageIndexSlice';
import { EngageLettersState, createEngageLettersSlice } from './engage/createEngageLettersSlice';
import {
    EngageWorkflowsState,
    createEngageWorkflowsSlice,
} from './engage/createEngageWorkflowsSlice';
import {
    EngageSMSNumberState,
    createSMSFeatureCalloutSlice,
} from './onboarding/createEngageSMSNumbersSlice';
import {
    NonprofitEinCalloutState,
    createNonprofitEinCalloutSlice,
} from './onboarding/createNonprofitEinCalloutSlice';
import {
    OnboardingChartState,
    createOnboardingChartParamsSlice,
} from './onboarding/createOnboardingChartParamsSlice';
import {
    GivebutterPlusState,
    createGivebutterPlusSlice,
} from 'contexts/account/createGivebutterPlusSlice';
import { PayoutsState, createPayoutsSlice } from 'contexts/account/createPayoutsSlice';
import {
    CampaignItemsState,
    createCampaignItemSlice,
} from 'contexts/campaigns/createCampaignItemSlice';
import {
    DismissMatchFulfilledNotificationState,
    createDismissMatchFulfilledNotificationSlice,
} from 'contexts/campaigns/createDismissMatchFulfilledNotificationSlice';
import {
    DataHygieneIgnoreAlertsState,
    createDataHygieneIgnoreAlertsSlice,
} from 'contexts/contacts/createDataHygieneIgnoreAlertsSlice';
import {
    EngageLetterEasySendCalloutState,
    createEngageLetterEasySendCalloutSlice,
} from 'contexts/engage/createEngageLetterEasySendCalloutSlice';
import {
    SelectedWidgetPlatformState,
    createSelectedWidgetPlatformSlice,
} from 'contexts/widgets/createSelectedWidgetPlatformSlice';
import {
    SkipWidgetLibraryInstallationState,
    createSkipWidgetLibraryInstallationSlice,
} from 'contexts/widgets/createSkipWidgetLibraryInstallationSlice';
import { createJSONStorage, persist } from 'zustand/middleware';
import { createWithEqualityFn as create } from 'zustand/traditional';

export type LocalStorageState = NonprofitEinCalloutState &
    EngageSMSNumberState &
    OnboardingChartState &
    SkipWidgetLibraryInstallationState &
    SelectedWidgetPlatformState &
    EngageLettersState &
    EngageWorkflowsState &
    DismissMatchFulfilledNotificationState &
    CampaignItemsState &
    EngageMessagesState &
    EngageLetterEasySendCalloutState &
    GivebutterPlusState &
    DataHygieneIgnoreAlertsState &
    PayoutsState;
export const useLocalStorage = create<LocalStorageState>()(
    persist(
        (...params) => ({
            ...createNonprofitEinCalloutSlice(...params),
            ...createOnboardingChartParamsSlice(...params),
            ...createSMSFeatureCalloutSlice(...params),
            ...createSelectedWidgetPlatformSlice(...params),
            ...createSkipWidgetLibraryInstallationSlice(...params),
            ...createEngageLettersSlice(...params),
            ...createEngageWorkflowsSlice(...params),
            ...createEngageMessagesSlice(...params),
            ...createDismissMatchFulfilledNotificationSlice(...params),
            ...createCampaignItemSlice(...params),
            ...createEngageLetterEasySendCalloutSlice(...params),
            ...createGivebutterPlusSlice(...params),
            ...createDataHygieneIgnoreAlertsSlice(...params),
            ...createPayoutsSlice(...params),
        }),
        {
            name: 'givebutter-localstorage-state',
            storage: createJSONStorage(() => localStorage),
        },
    ),
);
